import { useSafeLayoutEffect } from '@/hooks/useSafeLayoutEffect/useSafeLayoutEffect';
import clsx from 'clsx';
import { useState } from 'react';
import Picture from '../Picture/Picture';
import styles from './LogoMarquee.module.scss';
import type { LogoMarqueeProps } from './types';

const LogoMarquee = ({ items, direction = 'left' }: LogoMarqueeProps) => {
  const [isAnimated, setIsAnimated] = useState(false);
  const hasItems = items && items.length > 0;

  useSafeLayoutEffect(() => {
    const prefersReducedMotion = window?.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (!prefersReducedMotion) {
      setIsAnimated(true);
    }
  }, []);

  if (!hasItems) {
    return null;
  }

  const duplicationAmount = items.length < 3 ? 5 : 3;
  const animationDuration = items.length * (1 + duplicationAmount);

  return (
    <div
      className={styles.base}
      data-animated={isAnimated ? 'true' : undefined}
      data-direction={direction}
      style={
        {
          '--animation-duration': `${animationDuration}s`,
        } as React.CSSProperties
      }
    >
      <ul className={styles.logoList}>
        {items.map(({ id, image }) => (
          <li key={id} className={styles.logoItem}>
            <Picture asset={image} className={clsx(styles.logo)} />
          </li>
        ))}
        {isAnimated &&
          Array.from({ length: duplicationAmount }, (_, index) =>
            items.map(({ id, image }) => (
              <li
                key={`${id}-${index}-duplicate`}
                className={styles.logoItem}
                aria-hidden="true"
              >
                <Picture asset={image} className={clsx(styles.logo)} />
              </li>
            ))
          )}
      </ul>
    </div>
  );
};

export default LogoMarquee;
